import React from 'react';
import './ArtDiptych.css';

interface ArtDiptychProps {
  leftContent: {
    text: string;
    backgroundColor?: string;
  };
  rightContent: {
    image?: string;
    video?: string;
    alt: string;
  };
}

const ArtDiptych: React.FC<ArtDiptychProps> = ({ leftContent, rightContent }) => {
  return (
    <section className="art-diptych">
      <div className="diptych-container">
        <div 
          className="diptych-left" 
          style={{ backgroundColor: leftContent.backgroundColor || 'var(--color-iguazu, #3e5b58)' }}
        >
          <div className="diptych-text">
            <h1>{leftContent.text}</h1>
          </div>
          
          {/* Bird graphic */}
          <div className="bird-graphic">
            <img src="/assets/8bb52215941c74ab65b85aa4225290b2805046ba.png" alt="Bird illustration" />
          </div>
        </div>
        
        <div className="diptych-right">
          {rightContent.video ? (
            <video 
              src={rightContent.video} 
              autoPlay 
              loop 
              muted 
              playsInline
              aria-label={rightContent.alt}
            />
          ) : (
            <img src={rightContent.image} alt={rightContent.alt} />
          )}
        </div>
      </div>
    </section>
  );
};

export default ArtDiptych;